import { render } from "./CreateTest.vue?vue&type=template&id=3c579fe4&scoped=true"
import script from "./CreateTest.vue?vue&type=script&lang=js"
export * from "./CreateTest.vue?vue&type=script&lang=js"

import "./CreateTest.vue?vue&type=style&index=0&id=3c579fe4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c579fe4"]])

export default __exports__